import { FC } from 'react'
import { useSelector } from 'react-redux'
import { selectUsuarioActual } from '../../../redux/slices/autenticacion/autenticacion.slice'
import { AppMapas } from '../../../utils/Constantes'
import { KTSVG } from '../../helpers/components'
import { useNavigate } from 'react-router-dom'
import { useLogout } from '../../../hooks/useLogout'

/**
 * Dropdown del usuario: muestra nombre, email, perfil, enlace a Ajustes y boton de cerrar sesion.
 */
const HeaderUserMenu: FC = () => {
  const navigate = useNavigate()
  const usuarioActual = useSelector(selectUsuarioActual)
  const { logout, isLoading } = useLogout()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 mw-325px'
      data-kt-menu='true'>
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='d-flex flex-column flex-grow-1 justify-content-between'>
            <div className='d-flex align-items-center justify-content-between'>
              <div>
                <div>{`${usuarioActual?.nombre} ${usuarioActual?.apellidoPaterno}`} </div>
                <div className='fw-bold text-muted text-hover-primary fs-7'>
                  {usuarioActual?.email}
                </div>
              </div>
              <div>
                {usuarioActual?.perfil && (
                  <span
                    className={`badge badge-light-${AppMapas.MAPA_PERFIL_USUARIO.get(
                      usuarioActual?.perfil
                    )} fw-bolder fs-7 px-2 py-1 ms-2`}>
                    {usuarioActual?.descPerfil}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-3'>
        <button
          className='btn w-100 text-start btn-active-light-primary btn-active-icon-dark ps-4'
          onClick={() => {
            navigate('ajustes')
            document?.getElementById('kt_header')?.click()
          }}>
          <i className='fa-solid fa-gear me-2 mh-50px'></i>
          Ajustes
        </button>
      </div>
      <div className='separator my-2'></div>
      <div className='menu-item px-3'>
        <button
          className='btn w-100 text-start btn-active-light btn-active-icon-dark ps-2'
          onClick={logout}
          disabled={isLoading}>
          <KTSVG path='/svg/sign-out.svg' className='svg-icon-1' />
          Cerrar sesión
        </button>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
